export default (model) => {
  if (!model?.type) return 1;
  return model?.type === 'ielts' ? 0.1 : 1;
};
